<template>
  <div :class="classes">
    <div class="bar"></div>
  </div>
</template>

<script>
import VIcon from "../icon/Icon.vue";

export default {
  name: "v-loading-bar",
  computed: {
    classes() {
      return ["v-loading-bar"];
    }
  }
};
</script>

<style lang="scss">
@import "../../design/variables.scss";

.v-loading-bar {
  overflow: hidden;
  background-color: #fafafa;

  .bar {
    height: 3px;
    animation: bar 1500ms linear infinite;
    background-color: map-deep-get($colors, "foreground", "action");
  }
}

@keyframes bar {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
